export type RouteSegment = {
  /** Index of the first route point of the segment. */
  start: number;
  /** Index of the last route point of the segment, shared with the next segment. */
  end: number;
  /** Position of the segment along the route, 0 at the start and 1 at the end. */
  ratio: number;
};

/**
 * Splits a route of `pointCount` points into consecutive segments that share their boundary points,
 * so each segment can get its own color and the line still looks continuous. The segments are
 * fixed for the whole route, so their colors do not shift while the route is being drawn.
 */
export const getRouteSegments = (pointCount: number, maxSegments: number): RouteSegment[] => {
  if (pointCount < 2) {
    return [];
  }

  const segmentCount = Math.min(maxSegments, pointCount - 1);
  const pointsPerSegment = (pointCount - 1) / segmentCount;

  return Array.from({length: segmentCount}, (_, index) => ({
    start: Math.round(index * pointsPerSegment),
    end: Math.round((index + 1) * pointsPerSegment),
    ratio: segmentCount === 1 ? 1 : index / (segmentCount - 1),
  }));
};
